import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ThemesService } from 'src/app/services/commonService/themes.service';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { Subject, takeUntil } from 'rxjs';
import { DialogService } from 'src/app/services/dialogs/dialog.service';
import { ContactUpdateDialogComponent } from 'src/app/shared/components/dialogs/contact-update-dialog/contact-update-dialog.component';
import { ThankyouService } from 'src/app/shared/common/thankyou.service';
import { ThankYouConfig } from '../../models/RegistrationModel';
import { CiamService } from 'src/app/services/CIAM/ciam.service';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { HelpAndSupportDatalayerService } from 'src/app/services/dataLayer/help-and-support-datalayer.service';
import { HelpAndSupportService } from '../../services/helpAndSupportContent.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';

@Component({
  selector: 'app-registration-thankyou',
  templateUrl: './registration-thankyou.component.html',
  styleUrls: ['./registration-thankyou.component.scss'],
  imports: [NgIf, MatButton, MatIcon]
})
export class RegistrationThankyouComponent implements OnInit, OnDestroy {
  getHelpAndSupportContent = inject(HelpAndSupportService);
  private readonly helpAndSupportGTM = inject(HelpAndSupportDatalayerService)
  flow: any;
  email?: string;
  mobile?: string;
  content: any;
  isregistration: boolean = false;
  islogin: boolean = false;
  showHeadingtxt!: string;
  showDescriptiontxt!: string;
  btnTxt!: string;
  uiMode: string = 'default';
  couintrycode!: any;
  mobilenumber!: any;
  cimToken!: any;
  isShowButton: boolean = true;
  isShowIcon: boolean = true;
  config!: any;
  /** Set when landing from Auth0 logout after corporate domain update (full page load; service has no config). */
  private thankYouHydratedFromQuery = false;
  helpAndSupport: any;
  thankYouToast: any;
  private destroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private readonly route: ActivatedRoute,
    private _ThemeService: ThemesService,
    private _DataLayerService: DataLayerService,
    private contentService: SignUpContentServiceService,
    private dialogService: DialogService,
    private readonly thankYouService: ThankyouService,
    private readonly _ciamService: CiamService,
    private _companyManagementService: CompanyManagementService,
  ) { }
  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('from') === 'corporateDomainUpdate') {
      this.thankYouHydratedFromQuery = true;
      this.config = {
        heading: "You've been logged out!",
        buttonText: 'Go to Login',
        redirectUrl: '',
        isShowButton: true
      };
      this.router.navigate([], { relativeTo: this.route, queryParams: {}, replaceUrl: true });
    }

    this.contentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
      });
    this.getHelpAndSupportContent.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.thankYouToast = res?.toastMessageList?.find((t: any) => t.messageID === 'b2b.help.thankyou');
    });
    this._ThemeService.setTheme('registerpage');
    this.thankYouService.config$
      .pipe(takeUntil(this.destroy$))
      .subscribe((config: ThankYouConfig | null) => {
        if (this.thankYouHydratedFromQuery) {
          return;
        }
        if (!config) {
          this.router.navigate(['/']);
          return;
        }

        this.config = config;
        this.couintrycode = config.countryCode;
        this.mobilenumber = config.mobile;
        this.cimToken = config.ciamToken;

        console.log('Updated Thankyou config:', config);
      });

    //--gtm
    const employeeType = this.config?.employeeType;
    const userType = employeeType === '0' ? 'Admin' : employeeType === '1' ? 'Travel Arranger' : 'Employee';
    if (employeeType === '0' || employeeType === '1' || employeeType === '2') {
      this._DataLayerService.langdingPageOnboardThankYou(userType);
    }
    console.log(this.thankYouToast?.CTAText, this.config?.buttonText);
    if (this.thankYouToast?.CTAText == this.config?.buttonText) {
      this.helpAndSupportGTM.visibleOfThankYourMassge('We received your complain');
    }
  }

  redirect() {
    const authType = this.config?.type ?? '';
    const employeeType = this.config?.employeeType;
    const userType = employeeType === '0' ? 'Admin' : employeeType === '1' ? 'Travel Arranger' : 'Employee';
    // Send GTM success event
    if (employeeType === '0' || employeeType === '1' || employeeType === '2') {
      this._DataLayerService.otpVerificationSuccessOnboarding(authType, 'Thank you for joining Saudia Business', 'Go to login', userType);
    }


    if (this.config.heading == 'Thank you for registering with Saudia Business') {
      this._DataLayerService.back_to_homePage(); //GTM use
      if (employeeType === '0' || employeeType === '1' || employeeType === '2') {
        this._DataLayerService.otpVerificationSuccessOnboarding(authType, 'Thank you for joining Saudia Business', 'Go to login', userType);
      }

    } else if (this.config.heading == 'Profile successfully created!' || this.config.heading == 'Profile Successfully linked') {
      if (employeeType === '0' || employeeType === '1' || employeeType === '2') {
        this._DataLayerService.otpVerificationErrorOnboarding('', 'Thank you for joining Saudia Business');
        this._DataLayerService.otpVerificationSuccessOnboarding(authType, 'Thank you for joining Saudia Business', 'Go to login', userType);
      }
      else if (this.config.heading == "You've been logged out!"){
        this._companyManagementService.email_domain_success('CTA Click','Back_to_login');
      }
    }
    if (this.cimToken != null) {
      this.updateMobileNumber();
      return;
    }
    if (this.thankYouToast?.CTAText == this.config?.buttonText) {
      this.helpAndSupportGTM.onClickOfDashboard();
    }
    if (this.config?.redirectUrl && this.config.redirectUrl.trim() !== '') {
      // If redirectUrl exists → navigate
      this.router.navigate([this.config.redirectUrl]);
    } else {
      // If redirectUrl is empty → call login
      this._ciamService.login();
    }

    setTimeout(() => {
      this.thankYouService.clear();
    }, 0);
  }

  // redirectToHomepage() {
  //   this.regUtilityService.setStep('corporate');
  //   this._DataLayerService.back_to_homePage(); //GTM use
  //   this.router.navigate(['/']);
  // }

  // redirectToLogin() {
  //   this.router.navigate(['/login'])
  // }

  updateMobileNumber() {
    this.dialogService.openDialog<ContactUpdateDialogComponent>(
      ContactUpdateDialogComponent,
      {
        data: {
          countryId: this.couintrycode,
          mobile: this.mobilenumber,
          ciamToken: this.cimToken,
        },
      },
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
